module.exports = __webpack_public_path__ + "img/2.e0a5ceaf.png";